module.exports = __webpack_public_path__ + "img/lock.6932eccd.svg";